/** @jsxImportSource @emotion/react */

import LoadingMatch from "../LoadingMatch";
import { ErrorMatchStyle } from "./index.style";

interface ErrorMatchProps {
  message: string;
}

const ErrorMatch = ({ message }: ErrorMatchProps) => {
  return (
    <div css={ErrorMatchStyle.wrapper}>
      <div className="state-disabled-content" aria-hidden="true">
        <LoadingMatch />
      </div>

      <div className="state-overlay">
        <p className="state-message">{message}</p>
      </div>
    </div>
  );
};

export default ErrorMatch;
